"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rpcProviders = exports.RpcProviderSlug = void 0;
var RpcProviderSlug;
(function (RpcProviderSlug) {
    RpcProviderSlug["Local"] = "local";
    RpcProviderSlug["Alchemy"] = "alchemy";
    RpcProviderSlug["Infura"] = "infura";
    RpcProviderSlug["Quiknode"] = "quiknode"; // Quicknode endpoints are spelled without the c, so we will use that spelling
})(RpcProviderSlug = exports.RpcProviderSlug || (exports.RpcProviderSlug = {}));
exports.rpcProviders = {
    [RpcProviderSlug.Local]: {
        name: 'Local',
        wsSupported: false
    },
    [RpcProviderSlug.Alchemy]: {
        name: 'Alchemy',
        wsSupported: true
    },
    [RpcProviderSlug.Infura]: {
        name: 'Infura',
        wsSupported: false
    },
    [RpcProviderSlug.Quiknode]: {
        name: 'Quiknode',
        wsSupported: true
    }
};
